document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("collections")) return;

  const container = document.querySelector(".collection-hero__description.rte");
  const wordLimit = 220;

  if (!container) return;

  const fullHTML = container.innerHTML.trim();
  const firstElement = container.firstElementChild;

  if (!firstElement) return;

  const firstElementText = firstElement.textContent.trim();
  const firstElementWords = firstElementText.split(/\s+/).filter(Boolean);
  const firstElementWordCount = firstElementWords.length;

  let collapsedHTML = "";

  // Case 1:
  // First element is shorter than or equal to the word limit.
  // Show the full first element content, then "... Read More" inline.
  if (firstElementWordCount <= wordLimit) {
    const clonedElement = firstElement.cloneNode(true);

    clonedElement.insertAdjacentHTML(
      "beforeend",
      `... <span class="toggle-btn collection-read-more">Read More</span>`
    );

    collapsedHTML = clonedElement.outerHTML;
  } else {
    // Case 2:
    // First element exceeds the word limit.
    // Show only limited words, then "... Read More" inline.
    const shortText = firstElementWords.slice(0, wordLimit).join(" ");
    const tagName = firstElement.tagName.toLowerCase();

    collapsedHTML = `
      <${tagName}>
        ${shortText}... <span class="toggle-btn collection-read-more">Read More</span>
      </${tagName}>
    `;
  }

  function showCollapsed() {
    container.innerHTML = collapsedHTML;

    const btn = container.querySelector(".toggle-btn");
    if (btn) {
      btn.addEventListener("click", showExpanded);
    }
  }

  function showExpanded() {
    container.innerHTML = `
      ${fullHTML}
      <span class="toggle-btn collection-read-more">Read Less</span>
    `;

    const btn = container.querySelector(".toggle-btn");
    if (btn) {
      btn.addEventListener("click", showCollapsed);
    }
  }

  showCollapsed();
});